import { Type } from 'class-transformer';
import { JournalEntryAttachmentResultDto } from './journal-entry-attachment-result-dto';
import { JournalEntryItemResultDto } from './journal-entry-item-result-dto';

export class JournalEntryDetailsResultDto {
    glJournalId: number;

    @Type(() => Date)
    postDate: Date;
    cashOrAccrual: string;
    description: string;
    @Type(() => Date)
    deletedDate: Date;
    reversed: boolean;
    @Type(() => Date)
    reversalDate: Date;
    reversalOfJournalId: number;

    entityUsesSubCategory: boolean;
    @Type(() => JournalEntryItemResultDto)
    items: JournalEntryItemResultDto[];
    @Type(() => JournalEntryAttachmentResultDto)
    attachments: JournalEntryAttachmentResultDto[];
    sourceReferenceId: number;
    sourceReferenceType: string;

    allowEdit: boolean;
    allowLimitedEdit: boolean;
    allowDelete: boolean;
    allowReverse: boolean;
    allowDuplicate: boolean;
    allowAttachment: boolean;
    allowViewDeposit: boolean;
}
